import React from "react";
import "./ocrDropZone.scss";
import { AiOcr, UploadImgIcon } from "../../../assets/images";
import { UploadIconMultiColor } from "../../Icon";

type AppProps={
    handleRedirectOcr:()=>void;
}

const InvoiceOcrBanner = ({handleRedirectOcr}:AppProps) => {
  return (
    <div className="ocr-invoice">
      <div className="banner-icon">
        <img src={AiOcr} alt="AI Icon" />
      </div>
      <div className="banner-content">
        <h2>AI-Driven Invoicing: Upload and Generate Instantly!</h2>
        <p>
          Effortlessly create invoices with AI—upload a PDF or image for instant
          data extraction or add them manually with ease.
        </p>
        <button className="upload-button" onClick={handleRedirectOcr}>
            <span>

        <UploadIconMultiColor/>
            </span>
          Upload File or Image
        </button>
      </div>
    </div>
  );
};

export default InvoiceOcrBanner;
